// Report Types
export const REPORT_TYPE_BAC_ID = 1;
export const REPORT_TYPE_DRIVER_ID = 2;
export const REPORT_TYPE_FATAL_SUPPLEMENT_ID = 3;
export const REPORT_TYPE_INVESTIGATOR_ID = 4;
export const REPORT_TYPE_LETTERS_MEMOS_ID = 5;
export const REPORT_TYPE_NON_MOTORIST_SUPPLEMENT_ID = 6;
export const REPORT_TYPE_OTHER_ID = 7;
export const REPORT_TYPE_PHOTOS_ID = 8;
export const REPORT_TYPE_TRUCK_BUS_SUPPLEMENT = 9;
export const REPORT_TYPE_SPD_ID = 10;
export const REPORT_TYPE_CONTINUATION_ID = 11;